import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import "swiper/css";
import MobileCard from "./mobile-card";
import { useWinnersCtx } from "@/contexts/winners";
import MobileCardSkeleton from "./mobile-card-skeleton";
import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";

function LeftArrow({ onClick, size = 36 }: any) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 58 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <rect width="58" height="58" rx="29" fill="#FFF4E3" />
      <path
        d="M27.375 22L20.375 29L27.375 36M37.625 29L21 29"
        stroke="black"
        strokeWidth="1.5"
      />
    </svg>
  );
}

function RightArrow({ onClick, size = 36 }: any) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 58 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <rect width="58" height="58" rx="29" fill="#FFF4E3" />
      <path
        d="M30.625 22L37.625 29L30.625 36M20.375 29L37 29"
        stroke="black"
        strokeWidth="1.5"
      />
    </svg>
  );
}

function NavigationButtons() {
  const swiper = useSwiper();
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  useEffect(() => {
    const handleSwiperChange = () => {
      setIsBeginning(swiper.isBeginning);
      setIsEnd(swiper.isEnd);
    };

    swiper.on("slideChange", handleSwiperChange);

    return () => {
      swiper.off("slideChange", handleSwiperChange);
    };
  }, [swiper]);

  return (
    <div className="absolute inset-0 z-10">
      <div
        className={cn(
          "absolute left-2 top-1/2 -translate-y-1/2 transform cursor-pointer rtl:left-auto rtl:right-2 rtl:-rotate-180",
          {
            "cursor-not-allowed opacity-40": isBeginning,
          },
        )}
      >
        <LeftArrow onClick={() => !isBeginning && swiper.slidePrev()} />
      </div>
      <div
        className={cn(
          "absolute right-2 top-1/2 -translate-y-1/2 transform cursor-pointer rtl:left-2 rtl:right-auto rtl:rotate-180",
          {
            "cursor-not-allowed opacity-40": isEnd,
          },
        )}
      >
        <RightArrow onClick={() => !isEnd && swiper.slideNext()} />
      </div>
    </div>
  );
}

export default function MobileCarousel({ winners }: any) {
  const { loading } = useWinnersCtx();
  if (winners.length == 0 || loading) {
    return (
      <div className="lg:hidden">
        <Swiper
          spaceBetween={12}
          slidesPerView={1}
          centeredSlides={true}
          initialSlide={1}
        >
          {Array.from({ length: 3 }).map((_, index: number) => (
            <SwiperSlide key={index}>
              {({ isActive }) => <MobileCardSkeleton isSelected={isActive} />}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    );
  }
  return (
    <div className="lg:hidden">
      <Swiper
        spaceBetween={12}
        slidesPerView={1}
        centeredSlides={true}
        initialSlide={1}
      >
        <NavigationButtons />
        {winners.map((winner: any, index: number) => (
          <SwiperSlide key={index}>
            {({ isActive }) => <MobileCard isSelected={isActive} {...winner} />}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
